const THEME = 'theme';
const TEMPLATE = 'template';
export const AssetTypes = Object.freeze({
  THEME,
  TEMPLATE
});
export const ELEVATE_THEME_PATH = '@hubspot/elevate';